import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { SurgeryForm } from "~/components/form/health-profile/SurgeryForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.surgery;

export default function EditSurgery() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const surgery = findMedical(type, id);

    if (!surgery) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="surgeries">
            <SurgeryForm surgery={surgery} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
